module.exports = __webpack_public_path__ + "img/planet-venus.bb3df0cf.svg";